import React from "react"

interface DateIconProps {
  className?: string
  width?: string
  height?: string
  stroke?: string
  strokeWidth?: string
}

function DateIcon(props:Readonly<DateIconProps>) {
  const { className, width, height, stroke, strokeWidth } = props
  const cssClassName = className ?? ""
  const cssWidth = width ?? "18"
  const cssHeight = height ?? "18"
  const cssStroke = stroke ?? "#8083A3"
  const cssStrokeWidth = strokeWidth ?? "1.5"
  return (
    <span className="anticon anticon-datepicker ">
      <svg
        className={cssClassName}
        width={cssWidth}
        height={cssHeight}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 1.5V3.75"
          stroke={cssStroke}
          strokeWidth={cssStrokeWidth}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 1.5V3.75"
          stroke={cssStroke}
          strokeWidth={cssStrokeWidth}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.625 6.81836H15.375"
          stroke={cssStroke}
          strokeWidth={cssStrokeWidth}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 6.375V12.75C15.75 15 14.625 16.5 12 16.5H6C3.375 16.5 2.25 15 2.25 12.75V6.375C2.25 4.125 3.375 2.625 6 2.625H12C14.625 2.625 15.75 4.125 15.75 6.375Z"
          stroke={cssStroke}
          strokeWidth={cssStrokeWidth}
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.99588 10.2754H9.00262"
          stroke={cssStroke}
          strokeWidth={cssStrokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.22147 10.2754H6.2282"
          stroke={cssStroke}
          strokeWidth={cssStrokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.22147 13.2754H6.2282"
          stroke={cssStroke}
          strokeWidth={cssStrokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

export default DateIcon
